import Axios from "axios";
import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";
import { ACCESS_TOKEN_KEY } from "@iso/constants/common.constant";

import BaseService from "./base.service";
import { baseURL } from "./axios.utils";

export default class AiCheckHistoryService extends BaseService {
  getList = ({ type, facilityCredentialId, status, size, offset, sortBy, sortByType }) => {
    return this.axios.get(API_ENDPOINTS.AI_CHECK_LIST, {
      params: {
        type,
        facilityCredentialId,
        status,
        size,
        offset,
        sortBy: sortBy || "created_at",
        sortByType: sortByType ?? 1,
      },
    });
  };

  create = ({ type, structuredPayload, ...data }) => {
    return this.axios.post(API_ENDPOINTS.AI_CHECK_CREATE, {
      type,
      structuredPayload,
      ...data,
    });
  };

  normalize = ({ type, ...data }) => {
    return this.axios.post(API_ENDPOINTS.AI_CHECK_NORMALIZE, {
      type,
      ...data,
    });
  };

  getLinkedTask = ({ taskId }) => {
    return this.axios.get(API_ENDPOINTS.AI_CHECK_LINKED_TASK, {
      params: { taskId },
    });
  };

  getDetail = ({ executionId }) => {
    return this.axios.get(
      API_ENDPOINTS.AI_CHECK_DETAIL.replace("{executionId}", executionId)
    );
  };

  getPromotionPlanDetail = ({ executionId, planId, type = "promotion" }) => {
    return this.axios.get(
      API_ENDPOINTS.AI_CHECK_PROMOTION_PLAN_DETAIL.replace(
        "{executionId}",
        executionId
      ).replace("{planId}", planId),
      { params: { type } }
    );
  };

  exportCrawlData = ({ executionId, sheet }) =>
    Axios({
      url: `${baseURL}${API_ENDPOINTS.AI_CHECK_CRAWL_DATA_EXPORT.replace(
        "{executionId}",
        executionId
      )}`,
      method: "GET",
      params: sheet ? { sheet } : undefined,
      responseType: "blob",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN_KEY),
      },
    });
}
